import React, { useEffect, useState } from 'react';
import AttachmentIcon from '@atlaskit/icon/glyph/attachment';
import Tag from '@atlaskit/tag';
import TagGroup from '@atlaskit/tag-group';
import { v4 as uuidv4 } from 'uuid';
import './add-screenshot-util.scss';

type FileItem = {
  itemId: string;
  file: File;
};

export const AddScreenshot = (props: { onFileSelected: any }) => {
  const [files, setFiles] = useState<FileItem[]>([]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      const newFiles = Array.from(selectedFiles).map((file: File) => ({
        itemId: uuidv4(),
        file: file,
      }));
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };
  const handleTagRemove = (id: string) => {
    const updatedFiles = files.filter((file) => file.itemId !== id);
    setFiles(updatedFiles);
  };

  useEffect(() => {
    props.onFileSelected(files.map((file) => file.file));
  }, [files]);

  return (
    <div className="add-screenshot-attach-file">
      <label htmlFor="file-input" className="attachment-icon">
        <AttachmentIcon label="Attach file" size="medium" />
        {files.length === 0 && <span className="no-file-text">Attach an image</span>}
      </label>
      <input
        id="file-input"
        type="file"
        multiple
        accept="image/*"
        onChange={handleFileChange}
        data-testid="file-input"
      />
      {files && (
        <div className="file-attached-container">
          <TagGroup>
            {files.map((file) => (
              <Tag
                key={file.itemId}
                text={file.file.name}
                isRemovable={true}
                removeButtonLabel="Remove"
                onAfterRemoveAction={() => handleTagRemove(file.itemId)}
              />
            ))}
          </TagGroup>
        </div>
      )}
    </div>
  );
};
